import classNames from 'classnames';

import TickIcon from '@/assets/icons/tick.svg?react';

import styles from './Checkbox.module.scss';

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  children?: React.ReactNode;
  innerRef?: React.Ref<HTMLInputElement>;
}

const Checkbox: React.FC<Props> = ({
  children,
  disabled = false,
  innerRef,
  ...props
}) => (
  <label
    className={classNames(styles.wrapper, {
      [styles.disabled]: disabled,
    })}
  >
    <input
      type="checkbox"
      className={styles.input}
      disabled={disabled}
      ref={innerRef}
      {...props}
    />
    <TickIcon className={styles.icon} />
    <span className={styles.text}>{children}</span>
  </label>
);

export default Checkbox;
